<template>

  <div>
    <onboarding-card
      v-if="isAffiliatesEmpty"
      :steps="getOnboardingSteps()"
    />

    <!-- Filters -->
    <!--    :category-filter.sync="categoryFilter"-->
    <!-- Filters hidden as it's not related to affiliates list -->
    <!--    <filters-->
    <!--      :status-filter.sync="statusFilter"-->
    <!--    />-->

    <!-- Table Container Card -->
    <model-list-table
      ref="listTable"
      :store-module-name="storeModuleName"
      :table-columns="tableColumns"
      :filters-list="filtersList"
      :query-params="getQueryParams"
      add-action="sidebar"
      :view-action="true"
      edit-action="sidebar"
      :delete-action="!isAffiliatesEmpty"
      :extra-actions="[]"
      :sidebar="SidebarAddNewAffiliate"
      :is-sortable="false"
      @items-count="count => isAffiliatesEmpty = !count"
    />
  </div>
</template>

<script>
import store from '@/store'
import { ref, onUnmounted } from 'vue'
import { formatDate } from '@core/utils/filter'
import ModelListTable from '@/views/models/common/ModelListTable.vue'
import SidebarAddNewAffiliate from '@/views/models/affiliates/add/SidebarAddNewAffiliate.vue'
import { VBToggle } from 'bootstrap-vue'
import OnboardingCard from '@core/components/onboarding-card/OnboardingCard.vue'
import Filters from './Filters.vue'
import affiliateStoreModule from '../affiliateStoreModule'

export default {
  components: {
    OnboardingCard,
    Filters,
    ModelListTable,
  },
  directives: {
    'b-toggle': VBToggle,
  },

  methods: {
    getOnboardingSteps() {
      return [
        {
          icon: 'SearchIcon',
          iconVariant: 'info',
          title: this.$t('modules.affiliates.onboarding_card.step_1.title'),
          description: this.$t('modules.affiliates.onboarding_card.step_1.description'),
        },
        {
          icon: 'PlusCircleIcon',
          iconVariant: 'success',
          title: this.$t('modules.affiliates.onboarding_card.step_2.title'),
          description: this.$t('modules.affiliates.onboarding_card.step_2.description'),
        },
        {
          icon: 'Share2Icon',
          iconVariant: 'info',
          title: this.$t('modules.affiliates.onboarding_card.step_3.title'),
          description: this.$t('modules.affiliates.onboarding_card.step_3.description'),
        },
        {
          icon: 'DollarSignIcon',
          iconVariant: 'success',
          title: this.$t('modules.affiliates.onboarding_card.step_4.title'),
          description: this.$t('modules.affiliates.onboarding_card.step_4.description'),
        },
      ]
    },
  },
  setup() {
    const STORE_MODULE_NAME = 'affiliates'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, affiliateStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    // const categoryFilter = ref(null)
    const statusFilter = ref(null)
    const isAffiliatesEmpty = ref(true)

    const tableColumns = [
      {
        key: 'draggable',
        label: '',
        sortable: false,
        thClass: 'p-0',
        thStyle: 'width: 1px',
        tdClass: ['p-0', 'pl-1', 'draggable-handle', 'cursor-move'],
      },
      {
        key: 'checkbox',
        label: '',
        sortable: false,
      },
      { key: 'affiliate', sortable: true, label: 'modules.affiliates.s_c' },
      {
        key: 'created_at',
        label: 'Creation Date',
        formatter: formatDate,
        sortable: true,
      },
      {
        key: 'updated_at',
        label: 'Last Update',
        formatter: formatDate,
        sortable: true,
      },
      { key: 'is_active', sortable: true, label: 'Status' },
      { key: 'actions' },
    ]

    const filtersList = [/* categoryFilter, */statusFilter]
    const getQueryParams = () => ({
      // categories: categoryFilter.value,
      is_active: statusFilter.value,
    })

    return {
      isAffiliatesEmpty,

      // Extra Filters
      // categoryFilter,
      statusFilter,

      // Table props
      tableColumns,
      storeModuleName: STORE_MODULE_NAME,
      filtersList,
      getQueryParams,

      SidebarAddNewAffiliate,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">

$gray-300: #dee2e6 !default;
$border-color: $gray-300 !default;

::v-deep .b-table {
  tbody {
    tr {
      //cursor: move;
    }
  }
}

.b-table {
  tbody {
    tr.ready-for-drag {
      transform: translateY(-4px);
      box-shadow: 0 3px 10px 0 $border-color;
      transition: all 0.2s;
    }
    tr {
      &:has(td .draggable-handle) {
        transform: translateY(-4px);
        box-shadow: 0 3px 10px 0 $border-color;
        transition: all 0.2s;
      }
    }
  }
}

.btn-link:hover {
  color: #5d6064 !important;
}
</style>
